import { PhotoCaptureAttributeType, PhotoCaptureAssignmentTypes, PhotoCaptureAssignmentSubTypes } from "../../../domain/photoCapture";
import { PhotoCaptureAnswerControlType } from '../enums';
import { RouteConstant } from '../constants';
export const redirectToRoute = (history, answerControlType = '', questionAttributeType = '', assignmentType = PhotoCaptureAssignmentTypes.GENRIC_PHOTO_CAPTURE, assignmentSubType = '', qs = '', isMultiSelectionAllowed = false) => {
    switch (answerControlType) {
        case PhotoCaptureAnswerControlType.SCRIPT_QUESTION:
            redirectToScriptQuestionByAttributeType(history, questionAttributeType);
            break;
        case PhotoCaptureAnswerControlType.ADD_ATTACHMENT:
            redirectToRouteByAttributeType(history, questionAttributeType, assignmentType, assignmentSubType);
            break;
        case PhotoCaptureAnswerControlType.YES_NO_VALUE:
            history.push(`/${RouteConstant.PBE_YES_NO}`);
            break;
        case PhotoCaptureAnswerControlType.STATIC_SCREEN:
            redirectToStaticRouteByAssignmentType(history, questionAttributeType, assignmentType, assignmentSubType);
            break;
        case PhotoCaptureAnswerControlType.CHOICE_SELECTION:
            redirectToRouteForChoiceType(history, isMultiSelectionAllowed);
            break;
        default:
            history.push(`/${RouteConstant.PBE_GPC_MESSAGE}?${qs}`);
    }
};
const redirectToRouteForChoiceType = (history, isMultiSelectionAllowed) => {
    if (isMultiSelectionAllowed)
        history.push(`/${RouteConstant.PBE_MULTI_CHOICE_SELECTION}`);
    else
        history.push(`/${RouteConstant.PBE_SINGLE_CHOICE_SELECTION}`);
};
export const redirectToRouteByAttributeType = (history, questionAttributeType, assignmentType, assignmentSubType) => {
    switch (questionAttributeType) {
        case PhotoCaptureAttributeType.VIN_CAPTURE:
            history.push(`/${RouteConstant.PBE_IDENTIFICATION}`);
            break;
        case PhotoCaptureAttributeType.MILEAGE_CAPTURE:
            history.push(`/${RouteConstant.PBE_ODOMETER}`);
            break;
        case PhotoCaptureAttributeType.LICENSE_PLATE_CAPTURE:
            history.push(`/${RouteConstant.PBE_LICENSE_PLATE}`);
            break;
        case PhotoCaptureAttributeType.VIN_STICKER:
            history.push(`/${RouteConstant.PBE_VIN_STICKER}`);
            break;
        case PhotoCaptureAttributeType.SINGLE_WIDE_SHOT:
            history.push(`/${RouteConstant.PBE_WIDE_SHOT}`);
            break;
        case PhotoCaptureAttributeType.THREE_CLOSE_UP:
            history.push(`/${RouteConstant.PBE_CLOSEUP_SHOT}`);
            break;
        case PhotoCaptureAttributeType.FOUR_CORNERS_CAPTURE:
            history.push(`/${RouteConstant.PBE_FOUR_CORNERS}`);
            break;
        case PhotoCaptureAttributeType.VIDEO_CAPTURE:
            history.push(`/${RouteConstant.PBE_WALK_AROUND_VIDEO}`);
            break;
        case PhotoCaptureAttributeType.VIN_DECODE:
            history.push(`/${RouteConstant.PBE_VIN_DECODE}`);
            break;
        case PhotoCaptureAttributeType.WIDE_ENHANCED:
            history.push(`/${RouteConstant.PBE_WIDE_ENHANCED}`);
            break;
        case PhotoCaptureAttributeType.CLOSEUP_ENHANCED:
            history.push(`/${RouteConstant.PBE_CLOSEUP_ENHANCED}`);
            break;
        case PhotoCaptureAttributeType.SUMMARY:
            history.push(`/${RouteConstant.PBE_ESTIMATOR_SUMMARY}`);
            break;
        case PhotoCaptureAttributeType.DEFAULT:
            redirectByAssignmentTypeAndSubType(history, assignmentType, assignmentSubType);
            break;
    }
};
export const redirectToScriptQuestionByAttributeType = (history, questionAttributeType) => {
    switch (questionAttributeType) {
        case PhotoCaptureAttributeType.DEFAULT:
            history.push(`/${RouteConstant.PBE_CONFIGURE_HOME}`);
            break;
        case PhotoCaptureAttributeType.ACKNOWLEDGEMENT:
            history.push(`/${RouteConstant.PBE_TERMS_AND_CONDITIONS}`);
            break;
        case PhotoCaptureAttributeType.TERMINATE:
            history.push(`/${RouteConstant.PBE_TERMINATE}`);
            break;
    }
};
export const redirectByAssignmentTypeAndSubType = (history, assignmentType, assignmentSubType) => {
    switch (assignmentType) {
        case PhotoCaptureAssignmentTypes.PHOTO_CAPTURE:
            history.push(`/${RouteConstant.PBE_REQUEST_OPTIONAL}`);
            break;
        case PhotoCaptureAssignmentTypes.REQ_ADDITIONAL_PHOTO:
            history.push(`/${RouteConstant.PBE_REQUEST_ADDITIONAL}`);
            break;
        case PhotoCaptureAssignmentTypes.GENRIC_PHOTO_CAPTURE:
            assignmentSubType === PhotoCaptureAssignmentSubTypes.RP
                ? history.push(`/${RouteConstant.PBE_REQUEST_ADDITIONAL}`)
                : history.push(`/${RouteConstant.PBE_REQUEST_OPTIONAL}`);
    }
};
export const redirectToStaticRouteByAssignmentType = (history, questionAttributeType, assignmentType, assignmentSubType) => {
    switch (questionAttributeType) {
        case PhotoCaptureAttributeType.SELECT_SHOP:
            history.push(`/${RouteConstant.PBE_SELECT_SHOP}`);
            break;
    }
};
//# sourceMappingURL=GPCRoute.js.map